import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { steps } from '../step/stepSlice';
import Card from '../../components/Card';
import Input from '../../components/BaseInput';
import BaseButton from '../../components/BaseButton';
import { verifyCode, resendSmsCode } from './senderSlice';
import { roundNumber, calculateProcessingFee } from '../../lib/utils';
import styles from './ReceiptDetails.module.scss';
import ResendCounter from './ResendCounter';

function ReceiptDetailsTwoFactor(props) {
  const dispatch = useDispatch();
  const { step } = useSelector((state) => state.step);
  const isLoading = useSelector((state) => state.loading.isLoading);
  const { selected, paymentMethods } = useSelector((state) => state.paymentMethods);
  const { currencies, product } = useSelector((state) => state);
  const [smsCode, setSmsCode] = useState('');

  const [error, setError] = useState(false);

  useEffect(() => {
    if (step === steps.twoFactorAuthorization) {
      setSmsCode('');
      setError(false);
    }
  }, [dispatch, step]);

  if (step !== steps.twoFactorAuthorization) {
    return null;
  }

  const selectedPaymentMethod = paymentMethods.find((pm) => pm.type === selected);

  const processingFee = calculateProcessingFee(product.amount, selectedPaymentMethod);

  const totalString = currencies.sender
    ? `${roundNumber(
        roundNumber(currencies.sender.rate * processingFee, 2) +
          roundNumber(currencies.sender.rate * product.amount, 2),
        2
      )} ${currencies.sender.name}`
    : '';

  const onSubmit = async () => {
    if (smsCode.length === 6) {
      setError(false);
      const response = await dispatch(verifyCode(smsCode));
      if (response.type?.includes('rejected')) {
        setError(true);
      }
      return;
    }

    setError(true);
  };

  const smsCodeChangeHandler = (event) => {
    if (event.target.value.length <= 6) {
      setSmsCode(event.target.value);
    }
  };

  const onEnterHandler = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  const onResendHandler = () => {
    dispatch(resendSmsCode());
  };

  return (
    <Card step={steps.twoFactorAuthorization} showStep={false} title="Verify phone number">
      <div className="credit-card-details">
        <div className="card-details-wrapper">
          <div className="mb-12"></div>
          <div className="label">Confirmation code</div>
          <div className="number-input">
            <div className="form-group card-input">
              <Input
                type="number"
                name="smsCode"
                title="SMS Code"
                error={false}
                value={smsCode}
                onChange={smsCodeChangeHandler}
                onKeyPress={onEnterHandler}
              />
              <div className={[styles.error, error && styles.opacity100].join(' ')}>
                Incorrect or expired code.
              </div>
              <ResendCounter onResend={onResendHandler} loading={isLoading} />
              <div className="mb-12"></div>
              <BaseButton onClick={onSubmit}>{`Pay ${totalString}`}</BaseButton>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default ReceiptDetailsTwoFactor;
